import * as Sentry from '@sentry/nextjs';

export interface DataLayerEvent {
	event?: string;
	[key: string]: unknown;
}

export type PushToDataLayer = (args: DataLayerEvent) => void;

const pushToDataLayer: PushToDataLayer = (args) => {
	try {
		// NEXT_PUBLIC_DISABLE_GTM prevents the GTM container from loading, but we
		// still populate dataLayer so local dev and e2e tests can inspect analytics events
		if (typeof window === 'undefined') {
			return;
		}

		const windowWithDataLayer = window as typeof window & {
			dataLayer?: unknown[];
		};
		windowWithDataLayer.dataLayer = Array.isArray(windowWithDataLayer.dataLayer)
			? windowWithDataLayer.dataLayer
			: [];
		windowWithDataLayer.dataLayer.push(args);

		if (process.env.NEXT_PUBLIC_DISABLE_GTM) {
			// When GTM is disabled, also log to console for convenience
			console.log('Analytics event: ', args);
		}
	} catch (err) {
		console.error(err);
		Sentry.captureException(err);
	}
};

export default pushToDataLayer;
